import { fetchBrokerageList } from '@apis/brokerage'
import find from 'lodash/find'
import Vue from 'vue'

export const state = {
  brokerages: [],
  selected_brokerage_seq: null,
}

export const mutations = {
  SET_BROKERAGES(state, newValue) {
    state.brokerages = newValue
  },
  SET_SELECTED_BROKERAGE_SEQ(state, newValue) {
    state.selected_brokerage_seq = newValue ? newValue * 1 : null
  },
}

export const getters = {
  brokerage_info(state) {
    return find(state.brokerages, { seq: state.selected_brokerage_seq })
  },
}

export const actions = {
  init({ dispatch }) {
    dispatch('getBrokerages').catch((e) => Vue.toasted.error(e.message))
  },
  async getBrokerages({ commit, sate }) {
    if (state.brokerages.length) return

    try {
      const { data } = await fetchBrokerageList({ no_paging: 1 })

      commit('SET_BROKERAGES', data)
    } catch (e) {
      if (e.httpStatusCode !== 401) throw e
      commit('SET_BROKERAGES', [])
    }
  },
  async selectBrokerage({ commit }, payload) {
    commit('SET_SELECTED_BROKERAGE_SEQ', payload)
  },
}
